;(function() {
  'use strict'

  angular.module('core.services').factory('surveyFactory', service)

  /* @ngInject */
  function service() {
    var defaultListImage = './img/survey-icon.png'

    return {
      transform: transform,
    }

    function transform(data) {
      if (!_.isArray(data)) {
        data = [data]
      }
      // survey extras
      _.each(data, function(survey) {
        survey.extras = {}
        survey.extras.iconUrl = survey.listImageUrl || defaultListImage
        survey.extras.iconStyle = {
          'background-image': 'url(' + survey.extras.iconUrl + ')',
        }
        survey.extras.subtext =
          survey.questions.length +
          ' Question' +
          (survey.questions.length > 1 ? 's' : '')

        // question extras
        _.each(survey.questions, function(question, index) {
          var totalQuestions = survey.questions.length
          var currentQuestion = index + 1
          var percent = (currentQuestion / totalQuestions) * 100
          question.extras = {}
          question.extras.progress = percent
          question.extras.isLast = currentQuestion === totalQuestions
          question.extras.number = currentQuestion
          question.extras.total = survey.questions.length
        })
      })
    }
  }
})()
